import { IAgentStatusDeprecatedService } from '@agent/core/agent/agent-status-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { ChannelDeprecatedImpl } from '@commons/models/channel';
import { IContact } from '@commons/models/contact';
import { ILogService } from 'angular';
import { filter } from 'rxjs';

import {
  ActivityFacade,
  ActivityStatus,
  ActivityType,
  AgentStatus,
  COMETD_CLOSE_RESPONSE,
  COMETD_LYNC_PAUSE,
  COMETD_LYNC_PAUSE_END,
  IStateEvent,
  MessagingService,
} from '@contact/upgrade';

const MODULE_NAME = 'lync';

export interface ILyncService {}

export class LyncService implements ILyncService {
  static $inject: Array<string> = ['$log', 'messaging', 'agentStatusDeprecatedService', 'activityFacade', 'contactDeprecatedService'];

  public name = MODULE_NAME;

  private inProgress: boolean = false;

  constructor(
    private readonly $log: ILogService,
    private readonly messaging: MessagingService,
    private readonly agentStatusDeprecatedService: IAgentStatusDeprecatedService,
    private readonly activityFacade: ActivityFacade,
    private readonly contactDeprecatedService: IContactDeprecatedService
  ) {
    this.messaging
      .forRemote()
      .listen$(COMETD_LYNC_PAUSE)
      .subscribe(
        () => {
          this.$log.debug('receive lync pause');
          this.updateAgentState(true);
        },
        () => this.$log.error('error on lync pause')
      );

    this.messaging
      .forRemote()
      .listen$(COMETD_LYNC_PAUSE_END)
      .subscribe(() => {
        this.$log.debug('receive lync pause end');
        this.updateAgentState(false);
      });

    this.messaging
      .forRemote()
      .listen$(COMETD_CLOSE_RESPONSE)
      .subscribe(() => {
        this.$log.debug('receive close request');
        this.closeRequest();
      });

    /**
     * listen to pause state success
     */
    this.activityFacade.success$
      .pipe(
        // if type is LYNC
        filter(({ activity }) => activity.type === ActivityType.LYNC),
        // if status is CANCELED
        filter(({ current }) => current === ActivityStatus.CANCELED)
      )
      .subscribe(({ id }) => {
        this.activityFacade.updateTransition(id, ActivityStatus.FINISHED);
        this.$log.debug('[osv] pause finished');
      });

    // LYNC is in progress
    this.activityFacade.isTypeInprogress(ActivityType.LYNC).subscribe(inProgress => (this.inProgress = inProgress));

    // agent state success
    this.agentStatusDeprecatedService.success().subscribe((event: IStateEvent<AgentStatus>) => {
      if (this.inProgress && event.newState === AgentStatus.AVAILABLE) {
        this.updateAgentState(false);
      }
    });
  }

  private updateAgentState(addPause: boolean): void {
    let currentStatusContact = this.agentStatusDeprecatedService.getCurrentAgentState();
    if (addPause) {
      if (!this.inProgress) {
        this.activityFacade.openForm(ActivityType.LYNC);
      }
    } else {
      if (this.inProgress) {
        if (currentStatusContact === AgentStatus.NOT_WORKING) {
          this.activityFacade.updateTransitionByType(ActivityType.LYNC, ActivityStatus.FINISHED);
          this.$log.info('end Lync pause');
        } else {
          // Cancel pause
          this.activityFacade.updateTransitionByType(ActivityType.LYNC, ActivityStatus.CANCELED);
          this.$log.debug('[lync] pause canceled');
        }
      }
    }
  }

  private closeRequest(): void {
    let currentStatusContact = this.agentStatusDeprecatedService.getCurrentAgentState();
    if (currentStatusContact === AgentStatus.WORKING && !this.inProgress) {
      let contacts: IContact[] = this.contactDeprecatedService.getContactsByChannel(ChannelDeprecatedImpl.INCOMING_PHONE);
      if (contacts && contacts.length > 1) {
        this.$log.error("[lync] Impossible de couper l'appel");
      } else {
        this.contactDeprecatedService.close(contacts[0].responseId);
      }
      this.$log.debug("[lync] Fin d'appel");
    }
  }
}

export default MODULE_NAME;
